import script from "./calender.vue?vue&type=script&lang=ts&setup=true"
export * from "./calender.vue?vue&type=script&lang=ts&setup=true"

import "./calender.vue?vue&type=style&index=0&id=63653a50&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63653a50"]])

export default __exports__